import esri = __esri;

export const asSearchItem =  (selected:boolean) => (
  candidate: esri.Graphic,
  idx?: number
) => {
  const { attributes, geometry, LayerName } = candidate;
  const item: any = {
    ...attributes
  };
  item.LayerName = LayerName; 
  item.Geometry = geometry.clone();
  item.GeometryType = geometry.type;
  item.IsSelected = selected;
  return item;
  
};

